const systemNotificationsTypes = {
    GET_ACTIVE_CAMPAIGNS_PENDING: 'GET_ACTIVE_CAMPAIGNS_PENDING',
    GET_ACTIVE_CAMPAIGNS_SUCCESS: 'GET_ACTIVE_CAMPAIGNS_SUCCESS',
    GET_ACTIVE_CAMPAIGNS_ERROR: 'GET_ACTIVE_CAMPAIGNS_ERROR',

    SET_NOTIFICATION_CONTENT: 'SET_NOTIFICATION_CONTENT',

    RESPOND_PENDING: 'RESPOND_PENDING',
    RESPOND_SUCCESS: 'RESPOND_SUCCESS',
    RESPOND_ERROR: 'RESPOND_ERROR',
};

export default systemNotificationsTypes;
